const LEAVES = [
  { x: 31, y: 37, r: 24 },
  { x: 64, y: 23, r: 27 },
  { x: 97, y: 38, r: 25 },
  { x: 55, y: 51, r: 24 },
  { x: 84, y: 51, r: 23 },
];

export const WinterfellWeirwood = () => {
  /* Render */
  const render = () => (
    <svg
      className="absolute left-[1%] top-[34%] z-[5] h-[26%] w-[15%]"
      viewBox="0 0 130 160"
      preserveAspectRatio="xMidYMax meet"
    >
      <path
        d="M0 157Q59 138 128 155"
        fill="none"
        stroke="var(--yard-groundTop)"
        strokeWidth="9"
      />
      <path
        d="M53 151 59 88 47 60 26 39 52 56 65 79 74 48 95 27 81 55 73 94 80 151 65 143Z"
        fill="#e0dfda"
        stroke="#9caab4"
        strokeWidth="2"
      />
      <path
        d="M60 110 64 107M69 107 73 110M63 125Q67 120 71 125"
        fill="none"
        stroke="#82414a"
        strokeWidth="2"
      />
      {LEAVES.map(({ x, y, r }, index) => (
        <g key={x}>
          <circle
            cx={x}
            cy={y}
            r={r}
            fill={index % 2 ? "#934452" : "#a84a56"}
          />
          <path
            d={`M${x - r + 5} ${y - 7}q${r - 5} -17 ${r * 2 - 10} 0`}
            stroke="var(--yard-groundTop)"
            strokeWidth="4"
            strokeLinecap="round"
            fill="none"
          />
        </g>
      ))}
      <path d="m23 103 4 3-3 5-4-3ZM90 116l5 1-1 5-4-1Z" fill="#a84a56" />
    </svg>
  );

  return render();
};
